import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import "./termsandconditions.css";
import { ArrowUpward } from "@mui/icons-material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function TermsandConditions({ open, onClose }) {
  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={onClose}
        TransitionComponent={Transition}
      >
        <AppBar
          sx={{
            position: "sticky",
            background: "linear-gradient(to right, purple, yellow)",
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Terms and Conditions
            </Typography>
          </Toolbar>
        </AppBar>
        <div className="tandc" id="tandc">
          <List
            sx={{ margin: "10px 50px", maxHeight: "auto", overflowY: "auto" }}
          >
            <p>
              <span style={{color:"purple",fontFamily:'sans-serif',fontSize:'16px'}}>“Spelling!!!”</span> a product of S3N Software Group (“S3N”, “we”, or
              “us”) understands that you care about how information about you is
              collected and used. We respect your privacy and we are committed
              to protecting the personal information that you share with us.
            </p>
            <br />
            <h6>Your Privacy Matters</h6>
            <p>
              This Privacy Policy describes the privacy practices of S3N with
              respect to the information we collect from you, including
              information collected via our products, services and websites. We
              outline the types of information S3N collects, how we collect it,
              how we use it, and the options you have to restrict the collection
              and use of your personally identifiable information. By using
              S3N's products, services or Sites you signify your acceptance of
              S3N’s collection and use of your personal information in the
              manner and for the purposes described herein. If you do not agree
              to some aspect of Spelling!!!'s intended use of your information,
              you may use one or more of the methods described in this Privacy
              Policy to opt out of the specific type of collection or use of
              information. If you feel that these methods are insufficient to
              alleviate your concerns, or if the nature of the product and/or
              service we provide requires collection and use of information in a
              way that you object to, a final option is not use our products,
              services, or Sites or otherwise provide Spelling!!! with your
              personal information.
            </p>

            <br />
            <h6>Collection of Information</h6>
            <p>
              S3N may collect information about your personal information/your
              phone permissions at the time of installing Spelling!!!
              application after downloading the App from google play store. S3N
              may use these personal and privacy data only for purposes
              consistent with this Privacy Policy.
            </p>

            <br />
            <h6>Information we provie</h6>
            <p>
              We may ask you to provide personal information when you register
              the Spelling!!! app for a program or service, subscribe and share
              the application, use our product/s, fill out a form, or in
              connection with other activities, services and features or
              resources we make available to you at the time of application
              operation. We may ask you for: your name, title or position, email
              address, mailing address, phone number, and other personal
              information as appropriate. Please note that we do not
              intentionally collect any sensitive personal information relating
              to your health or medical history, racial or ethnic origins,
              political or religious beliefs or sexuality; please do not provide
              any of this type of information to us.
            </p>

            <br />
            <h6>Information Collected Automatically</h6>
            <p>
              To measure and improve the performance of our Sites, we may
              collect information during your visit to the Sites through our
              automatic data collection tools, which may include Web beacons,
              cookies, embedded Web links, pixel tags and other commonly used
              information-gathering tools. These tools help us track how users
              are interacting with our Sites, and help us make your visit to our
              Sites easier and more efficient by providing you with a customized
              experience and recognizing you when you return. S3N maintains its
              own pages on many social networking sites, and we may also collect
              information from you when you interact with our social networking
              pages.
            </p>
            <br />
            <h6>Why We Collect Information</h6>
            <p>
              S3N may collect and use your information for the following
              purposes:
            </p>
            <ul>
              <li>To personalize and customize your quiz questions.</li>
              <li>
                To improve customer service and respond to requests. Information
                you provide helps us respond to your service requests and
                support needs more efficiently, and enables us to contact you in
                response to your requests for product information and support.
              </li>
              <li>To improve our products and services.</li>
              <li>
                To process orders, warranty claims and payments from our users,
                independent dealers and distributors.
              </li>
              <li>
                To contact you by telephone to discuss your account or respond
                to requests and questions.
              </li>
              <li>
                To send you periodic emails. We may use email addresses provided
                to us to send information and updates pertaining to accounts,
                purchases, or products. It may also be used to respond to
                inquiries, questions, and/or other requests. If you decide to
                opt-in to our mailing list, you will also receive emails that
                may include company news, newsletters, surveys, updates, related
                product or service information, and the like.
              </li>
              <li>For other purposes when we have your consent.</li>
            </ul>

            <br />
            <h6>HOW WE PROTECT YOUR PERSONAL INFORMATION</h6>
            <p>
              Your personal information and data files are stored on S3N servers
              and the servers of companies we hire to provide us with storage
              services. S3N takes precautions including industry standard
              administrative, technical, and physical measures that are designed
              to safeguard the personal information collected from visitors and
              customers against loss, theft, misuse, unauthorized access,
              disclosure, alteration, and destruction. When you enter personal
              information on our forms, we encrypt this data using SSL or other
              technologies. These technologies are designed to protect the
              confidentiality of your personal information when it's transmitted
              over the Internet. Notwithstanding all of our efforts, no security
              controls are 100% effective and S3N cannot guarantee that third
              parties will never be able to defeat the security measures or use
              your personal information for improper purposes. In the event that
              your personal information under our control is compromised as a
              result of a breach of security, we will take reasonable steps to
              investigate the situation and where appropriate, notify those
              individuals whose information may have been compromised and take
              other steps in accordance with all applicable laws.
            </p>

            <br />
            <h4>WHEN WE DISCLOSE YOUR PERSONAL INFORMATION</h4>
            <h6>Generally</h6>
            <p>
              Your personal information may be shared with our subsidiaries and
              affiliates who are obligated to safeguard it in accordance with
              this Privacy Policy. There are also times when S3N makes certain
              personal information about you available to companies that help us
              run our business or that provide products and services to you on
              our behalf. These companies may use your personal information only
              to assist us accomplish one or more of the purposes for which we
              collected the information as set forth herein. For example, these
              partners may help us process information, manage and enhance
              customer data, provide customer service, assess your interest in
              our products and services, or conduct customer research or
              satisfaction surveys. Be assured, however, that S3N does not sell
              or rent your personal information to other third party marketers
              or spammers.
            </p>

            <h6>In Connection with Legal Process or Investigation</h6>
            <p>
              S3N may also disclose your personal information to a third party
              if required to do so by law or if, in good faith, S3N believes
              that such action is necessary to: (i) comply with the law or with
              legal process or to the extent required to protect national
              security; (ii) protect and defend legal rights or prevent fraud;
              (iii) protect against abuse, misuse or unauthorized use of S3N's
              products or services; (iv) protect the personal safety or property
              of personnel, users or the public; or, (v) to auditors or lawyers
              as required for the limited purpose of conducting audits or
              corporate due diligence.
            </p>

            <h6>CHILDREN'S PRIVACY</h6>
            <p>
              Protecting the privacy of the very young is especially important
              to S3N. For that reason, and in accordance with the Children's
              Online Privacy Protection Act, we never collect or maintain
              information at the Sites from those we actually know are under 13,
              and no part of the Sites is structured to attract anyone under 13.
            </p>

            <h6>
              ACCESSING AND UPDATING YOUR INFORMATION OR OPTING OUT
              COMMUNICATIONS FROM S3N
            </h6>
            <p>
              S3N takes reasonable steps to ensure that your personal
              information we process is accurate, complete and current by using
              the most recent information provided to us.
            </p>
            <p>S3N</p>
            <p>S3N Software Group LLC</p>

            <br />
            <h6>Address</h6>
            <p>2409 Hunters Green Court, Austin, TX 78732</p>

            <br />
            <h6>Changes</h6>
            <p>
              Our Privacy Policy may change from time to time, but we will not
              reduce the level of protection of your personal information
              collected pursuant to a previous version of this Privacy Policy
              without your consent. We will post any changes to our Privacy
              Policy on this page and changing the effective date. We encourage
              you to periodically review our privacy policy for the latest
              information on our privacy practices. For new users, the changes
              or updates will become effective upon posting. For existing users,
              the changes or updates will become effective 30 days after
              posting.
            </p>

            <br />
            <h6>QUESTIONS OR CONCERNS</h6>
            <p>
              If you have any questions or concerns about this policy or your
              information, please email us at{" "}
              <span style={{color:'purple', fontWeight: "bold" }}>
                spelling@s3nsoftware.com
              </span>
              .
            </p>
          </List>
        </div>
      </Dialog>
    </React.Fragment>
  );
}
